module.exports = __webpack_public_path__ + "static/media/shoe-prints.a0a4cd43.svg";